export {
  PageApiQueueProvider as FlashApiQueueProvider,
  usePageApiQueue as useFlashApiQueue,
} from "../../Components/Hooks/PageApiQueue";

/** Priority order matches Flash page component order */
export const FLASH_API_PRIORITY = {
  FoodCapital: 1,
  ForeCastCovers: 2,
  ForeCastRevOcc: 3,
  TrendAvgCheckCover: 4,
  ForeCastTotalRev: 5,
  WeekPerformance: 6,
};
